import styled, { css } from "styled-components";

export const StyledOverlay = styled.div<{
  $disableBackgroundColor: boolean;
}>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  ${(props) =>
    !props.$disableBackgroundColor &&
    css`
      background: var(--modal-background);
      backdrop-filter: blur(2px);
    `}
`;

StyledOverlay.displayName = "StyledOverlay";
